import iphone15 from '@/assets/iphone.png';
import macbook from '@/assets/macbook.png';
import Grid2 from '@mui/material/Grid2';
import { mockupDevicesContainerStyle, mockupDevicesContainerSize } from './style';
import './mockup_devices.css';

export const MockupDevices = () => {
  return (
    <Grid2 size={mockupDevicesContainerSize} className="right-login" sx={mockupDevicesContainerStyle}>
      <img src={iphone15} className="login-iphone" />
      <img src={macbook} className="login-macbook" />
    </Grid2>
  );
};
